<template>
  <el-upload
    class="upload-statement"
    action=""
    :file-list="fileList"
    accept="image/jpeg,image/jpg,image/png,application/pdf"
    :http-request="upload"
    :limit="1"
    :before-upload="beforeUpload"
    :on-remove="remove"
    name="事故认定书"
    :on-exceed="overwrite"
    :on-preview="preview"
    :disabled="isDisabled.value"
  >
    <div
      slot="tip"
      class="el-upload__tip"
    >
      只能上传jpg/jpeg/png/pdf文件
    </div>
    <el-button
      class="uploadbtn"
      type="primary"
      :loading="loading"
      :disabled="
        !($store.getters.isAdmin || $store.getters.accidentRoleName === '坐席')
      "
    >
      上传
    </el-button>
  </el-upload>
</template>
<script>
import {uploadStatement, removeStatement} from '@/api/accident/upload';

export default {
  inject: {isDisabled: {default: () => ({value: false})}},
  props: {
    accidentId: {
      type: String,
      required: true
    },
    statementUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    fileList() {
      if (this.statementUrl) {
        const name =
          '事故认定书.' +
          this.statementUrl
            .split('/')
            .pop()
            .split('.')
            .pop()
            .toLowerCase();
        return [{name, url: this.statementUrl}];
      } else {
        return [];
      }
    }
  },
  methods: {
    beforeUpload(file) {
      if (
        !'image/jpeg,image/jpg,image/png,application/pdf'
          .split(',')
          .includes(file.type)
      ) {
        this.$message.error('只能上传jpg/jpeg/png/pdf文件');
        return false;
      } else {

        if (file.size / 1024 / 1024 > 20) {
          this.$message.error('上传文件不能大于20兆')
          return false
        }


        return true;
      }
    },
    upload({file}) {
      const formData = new FormData();
      formData.append('file', file);
      this.loading = true;
      uploadStatement(this.accidentId, formData)
        .then(({data}) => {
          this.$message.success('上传成功');
          this.$emit('update:statementUrl', data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    remove() {
      removeStatement(this.accidentId).then(({data}) => {
        this.$message.success('删除成功');
      });
    },
    preview() {
      window.open(this.statementUrl, '_blank');
    },
    overwrite([file]) {
      this.upload({file});
    }
  }
};
</script>
<style lang="less">
.upload-statement {
  max-width: 600px;

  .el-upload-list__item.is-success.focusing {
    .el-icon-close-tip {
      display: none !important;
    }
  }

  .el-upload__tip {
    color: #17ECFE;
    margin-bottom: 25px;
  }

  .uploadbtn {
    width: 160px;
    height: 48px;
    background: #0ebd35;
    color: #FFFFFF;
    font-size: 20px;
  }

  .el-upload-list .el-upload-list--text {
    color: #0EBD35;
  }
}
</style>
